import React, { useCallback } from  'react';
import { Row, Col } from 'antd';

import DebouncedPicker from './DebouncedPicker';
import { GRID_COLUMN_WIDTH, GRID_ROW_HEIGHT } from './v3/PDFDesignerV3';

export default ({
  onDrawOptionChanged,
  drawOptions = {},
  style = {},
  useV3,
}) => {
  const {
    headerOptions = {},
  } = drawOptions;
  const onHeaderHeightChanged = useCallback(({ headerHeight }) => {
    const {
      headerOptions: oldHeaderOptions = {},
    } = drawOptions;
    onDrawOptionChanged({
      ...drawOptions,
      headerOptions: {
        ...oldHeaderOptions,
        headerHeight,
      },
    });
  },[drawOptions]);

  return (
    <Row  justify='space-between' gutter={10}>
      <Col span={12}>
        <DebouncedPicker
          optionKey='headerHeight'
          title='Header Height'
          drawOptions={headerOptions}
          style={style}
          max={500}
          min={useV3 ? GRID_ROW_HEIGHT : 6}
          step={useV3 ? GRID_ROW_HEIGHT : 1}
          onDrawOptionChanged={onHeaderHeightChanged}
        />
      </Col>
      <Col span={12}>
        <DebouncedPicker
          optionKey='rowHeight'
          title='Row Height'
          drawOptions={drawOptions}
          style={style}
          max={500}
          min={useV3 ? GRID_ROW_HEIGHT : 6}
          step={useV3 ? GRID_ROW_HEIGHT : 1}
          onDrawOptionChanged={onDrawOptionChanged}
        />
      </Col>
    </Row>
  );
}
